module.exports = __webpack_public_path__ + "static/media/smoothness_icon.e19c02da.png";